import {changeProductFavorite} from '../product/application/changeProductFavorite';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {initial, isPending, isSuccess} from './domain/RemoteData.model';
import {remoteDataWithSetter} from './utils/remoteDataWithSetter';
import {useComercialContext} from '../comercial/ComercialContext';

export const useItemFavorite = (catalogItem) => {
  const [changeFavoriteRemoteData, setChangeFavoriteRemoteData] = useState(initial(null));
  const [isFavorite, setIsFavorite] = useState(catalogItem.isFavorite);
  const actingAsNumCliente = useComercialContext()?.actingAsCliente?.numCliente ?? null;

  useEffect(() => {
    if (isSuccess(changeFavoriteRemoteData)) {
      setIsFavorite(changeFavoriteRemoteData.value);
    }
  }, [changeFavoriteRemoteData]);

  const postUpdate = useMemo(() =>
      () => changeProductFavorite(catalogItem.code, isFavorite, actingAsNumCliente),
    [catalogItem.code, isFavorite, actingAsNumCliente]
  );

  const changeFavorite = useCallback(async () => {
    if (!isPending(changeFavoriteRemoteData)) {
      await remoteDataWithSetter(setChangeFavoriteRemoteData, postUpdate);
    }
  }, [changeFavoriteRemoteData, postUpdate]);

  return { isFavorite, changeFavorite };
};